import React from "react";
import { Link } from "react-router-dom";
import { Clock, Lock } from "lucide-react";

export default function TrialBanner({ trial, plan }) {
  if (!trial?.on_trial) return null;

  if (trial.expired) {
    return (
      <div
        className="rounded-2xl border border-red-200 bg-red-50 p-4 sm:p-5"
        data-testid="trial-banner-expired"
      >
        <p className="flex items-center gap-2 font-display text-base font-semibold text-red-900">
          <Lock className="h-4 w-4" aria-hidden="true" />
          Your free trial has ended
        </p>
        <p className="mt-2 text-sm text-red-900/85">
          Nothing has been deleted — your content, calendar and Brand Profile are all still here. Generating,
          scheduling and publishing are paused until you choose a plan.
        </p>
        <Link
          to="/dashboard/subscription"
          data-testid="trial-banner-choose-plan"
          className="mt-4 inline-flex rounded-xl bg-slate-900 px-4 py-2.5 text-sm font-semibold text-white"
        >
          Choose my plan
        </Link>
      </div>
    );
  }

  const urgent = trial.days_left <= 3;
  return (
    <div
      className={`rounded-2xl border p-4 sm:p-5 ${urgent ? "border-amber-200 bg-amber-50" : "border-slate-200 bg-white"}`}
      data-testid="trial-banner"
    >
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <p className="flex items-center gap-2 font-display text-base font-semibold text-slate-900">
            <Clock className="h-4 w-4 text-[#F95738]" aria-hidden="true" />
            {trial.days_left} {trial.days_left === 1 ? "day" : "days"} left of your free trial
          </p>
          <p className="mt-1.5 text-sm text-slate-600">
            You have full {plan?.name === "Trial Ended" ? "Grow" : "trial"} access and you've paid €0 so far. Pick a
            plan before it ends and your scheduled posts keep going out without a gap.
          </p>
        </div>
        <Link
          to="/dashboard/subscription"
          data-testid="trial-banner-upgrade"
          className="inline-flex shrink-0 rounded-xl bg-[#F95738] px-4 py-2.5 text-sm font-semibold text-white"
        >
          Choose a plan
        </Link>
      </div>
    </div>
  );
}
